import React, { useRef } from "react";

import "../Asociados/asociadosTable.css";

import { ImagePathBuilder } from "helper/tools";
import SkeletonTable from "../Skeleton/SkeletonTable";
import { handleStatus } from "../../helperFunctions/helpers";
import BadgeStatus from "../Asociados/BadgeStatus";

/**
 *
 * @param {*} param0
 * @returns
 */

export default function ProductosTable2({
  items,
  openItem,
  handleSortChange,
  isLoading = false,
}) {
  const theadRef = useRef();

  function handleSort(event) {
    //data-order="desc"

    // Reference to the clicked header element
    const header = event.target;
    // Get the column to sort by from the data attribute
    const column = header.getAttribute("data-column");
    // Get the current sort order (asc or desc) from the data attribute
    const order = header.getAttribute("data-order");

    if (column?.length === 0) {
      return;
    }

    // Determine the new sort order by toggling the current order
    const newOrder = order === "desc" ? "asc" : "desc";
    // Update the data-order attribute with the new sort order
    header.setAttribute("data-order", newOrder);

    const value = event.target;

    console.log(value);

    console.log(theadRef);

    /** */
    const children = theadRef.current.children;
    for (let element of children) {
      element.classList.remove("dir-d", "dir-u");
      if (element === value) {
        const newOrderClass = newOrder === "desc" ? "dir-d" : "dir-u";
        element.classList.add(newOrderClass);
      }
    }

    handleSortChange({
      sortBy: column,
      sortAsc: newOrder,
    });
  }

  return (
    <>
      <table className="table table-borderless datable sortable table-hover">
        <thead className="table-light" style={{ textAlign: "center" }}>
          <tr ref={theadRef}>
            <th
              scope="col"
              data-column="Num"
              style={{ width: "50px" }}
              onClick={(event) => handleSort(event)}
            >
              Id
            </th>

            <th
              scope="col"
              data-column="nombre"
              onClick={(event) => handleSort(event)}
            >
              Nombre
            </th>
            <th
              scope="col"
              data-column="nombreCorto"
              onClick={(event) => handleSort(event)}
            >
              Nombre Corto
            </th>

            <th
              scope="col"
              data-column="activo"
              style={{ width: "50px" }}
              onClick={(event) => handleSort(event)}
            >
              Estatus
            </th>
          </tr>
        </thead>
        <tbody>
          {isLoading && <SkeletonTable columnCount={4} rowCount={4} />}

          {!isLoading &&
            items?.length > 0 &&
            items?.map((item) => {
              //    const imagePaths = item.productImagePathsString?.split(",") ?? [];
              //    const imagePath = imagePaths.length > 0 ? imagePaths[0] : "";
              //  const imageURL = ImagePathBuilder.to(imagePath);

              return (
                <tr key={item.id}>
                  <th scope="row">
                    <a href="#" onClick={(e) => openItem(item)}>
                      {item.num ?? ""}
                    </a>
                  </th>

                  <td>{item.nombre ?? ""}</td>
                  <td>{item.nombreCorto ?? ""}</td>
                  <BadgeStatus item={item} />
                </tr>
              );
            })}
        </tbody>
      </table>
    </>
  );
}
